import {Fragment, useEffect, useState} from 'react';

import {Checkbox} from 'primereact/checkbox';
import {InputText} from 'primereact/inputtext';
import {Button} from 'primereact/button';

export const OrderForm = (props) => {

  const [display, setDisplay] = useState(props.field.display);
  const [label, setLabel] = useState(props.field.label);
  const [songNgu, setSongNgu] = useState(props.field.songNgu);
  const [value, setValue] = useState(props.field.value);

  useEffect(() => {
    if (props.field.separator) {
      return;
    }
    setDisplay(props.field.display);
    setLabel(props.field.label);
    setSongNgu(props.field.songNgu ?? '');
    setValue(props.field.value ?? '');
  }, [props.field.separator, props.field.fieldId, props.field.display, props.field.label, props.field.songNgu, props.field.value]);

  const onDisplayChange = (value) => {
    setDisplay(value);

    let event;
    if (value) {
      event = new CustomEvent('setCss', {
        detail: {selector: `#${props.field.fieldId}`, property: 'display', value: ''}
      });
      props.dispatchEvent(event);

      event = new CustomEvent('setCss', {
        detail: {selector: `[dependency="${props.field.fieldId}"]`, property: 'display', value: ''}
      });
      props.dispatchEvent(event);
    } else {
      event = new CustomEvent('setCss', {
        detail: {selector: `#${props.field.fieldId}`, property: 'display', value: 'none'}
      });
      props.dispatchEvent(event);

      event = new CustomEvent('setCss', {
        detail: {selector: `[dependency="${props.field.fieldId}"]`, property: 'display', value: 'none'}
      });
      props.dispatchEvent(event);
    }

  }

  const onTextChange = (e) => {
    const value = e.target.value;

    let event;
    switch (e.target.name) {
      case 'label':
        setLabel(value);

        event = new CustomEvent('setText', {
          detail: {selector: `#${props.field.labelTarget}`, value}
        });
        break;
      case 'songNgu':
        setSongNgu(value);

        event = new CustomEvent('setText', {
          detail: {selector: `#${props.field.songNguTarget}`, value}
        });
        break;
      case 'value':
        setValue(value);

        event = new CustomEvent('setText', {
          detail: {selector: `#${props.field.valueTarget}`, value}
        });
        break;
      default:
    }
    if (event) {
      props.dispatchEvent(event);
    }
  }

  const onFocus = (e) => {
    const field: any = {
      fieldId: props.field.fieldId,
      addedField: props.field.addedField
    };
    switch (e.target.name) {
      case 'label':
        field.targetId = props.field.labelTarget;
        field.targetSetting = props.field.labelSetting;
        break;
      case 'songNgu':
        field.targetId = props.field.songNguTarget;
        field.targetSetting = props.field.songNguSetting;
        break;
      case 'value':
        field.targetId = props.field.valueTarget;
        field.targetSetting = props.field.valueSetting;
        break;
      default:
    }
    props.selectField(field);
  }

  if (props.field.separator) {
    return (
      <div className="grid">
        <div className="col-12 blank">
        </div>
      </div>
    );
  } else {
    return (
      <div className="p-fluid">
        <div className="grid">
          <div className="col-fixed pt-3" style={{width: '30px'}}>
            <Checkbox checked={display} onChange={e => onDisplayChange(e.checked)} disabled={!props.field.setDisplay}/>
          </div>
          <div className="col">
            <InputText type="text" className={props.field.labelDisabled ? 'p-inputtext-sm p-disabled' : 'p-inputtext-sm'} name="label"
                       value={label} onChange={onTextChange} onClick={onFocus}/>
          </div>
          {props.field.songNguWidth && (
            <div className="col-fixed" style={{width: props.field.songNguWidth}}>
              <InputText type="text" className={props.field.songNguDisabled ? 'p-inputtext-sm p-disabled' : 'p-inputtext-sm'} name="songNgu"
                         value={songNgu} onChange={onTextChange} onClick={onFocus}/>
            </div>
          )}
          {props.field.valueWidth && (
            <Fragment>
              <div className="col-fixed" style={{width: props.field.valueWidth}}>
                <InputText type="text" className={props.field.valueDisabled ? 'p-inputtext-sm p-disabled' : 'p-inputtext-sm'} name="value"
                           value={value} onChange={onTextChange} onClick={onFocus}/>
              </div>
              <div className="col-fixed" style={{width: '40px'}}>
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-warning p-button-outlined p-button-sm p-button-2rem" onClick={event => props.showEditField(props.field)}/>
              </div>
            </Fragment>
          )}
          {(!props.field.valueWidth && props.field.editWidth) && (
            <div className="col-fixed" style={{width: '40px'}}>
              <Button icon="pi pi-pencil" className="p-button-rounded p-button-warning p-button-outlined p-button-sm p-button-2rem" onClick={event => props.showEditField(props.field)}/>
            </div>
          )}
        </div>
      </div>
    );
  }

}
